import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { LoadingState, PageHeader, Section } from '../components/public/ui';

const Contact = () => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContactData = async () => {
      try {
        const response = await api.get('/public/contact');
        setPageData(response.data.data);
      } catch (error) {
        console.error('Error fetching contact data:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchContactData();
  }, []);

  if (loading) return <LoadingState />;

  const title = pageData?.title?.trim() || 'Contacto';
  const content = pageData?.content?.trim() || '';
  const location = pageData?.location?.trim() || '';
  const whatsapp = pageData?.whatsapp_link?.trim() || '';
  const instagram = pageData?.instagram_link?.trim() || '';
  const scheduleTitle = pageData?.schedule_title?.trim() || '';
  const scheduleText = pageData?.schedule_text?.trim() || '';
  const hasLinks = Boolean(whatsapp || instagram);
  const hasDetails = Boolean(location || hasLinks);

  return (
    <Section className="section-pad !max-w-3xl">
      <PageHeader title={title} lead={content || undefined} />

      {hasDetails && (
        <div className="rounded-lg border border-line bg-surface p-6 md:p-8">
          <dl className="grid gap-6 sm:grid-cols-2">
            {location && (
              <div className="sm:col-span-2">
                <dt className="text-xs font-semibold uppercase tracking-wide text-muted">Ubicación</dt>
                <dd className="mt-1 whitespace-pre-line font-medium">{location}</dd>
              </div>
            )}

            {whatsapp && (
              <div>
                <dt className="text-xs font-semibold uppercase tracking-wide text-muted">WhatsApp</dt>
                <dd className="mt-1">
                  <a
                    href={whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-semibold text-primary hover:text-primary-dark"
                  >
                    Enviar mensaje
                  </a>
                </dd>
              </div>
            )}

            {instagram && (
              <div>
                <dt className="text-xs font-semibold uppercase tracking-wide text-muted">Instagram</dt>
                <dd className="mt-1">
                  <a
                    href={instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-semibold text-primary hover:text-primary-dark"
                  >
                    Síguenos
                  </a>
                </dd>
              </div>
            )}
          </dl>

          {hasLinks && (
            <div className="mt-8 flex flex-wrap gap-3">
              {whatsapp && (
                <a href={whatsapp} target="_blank" rel="noopener noreferrer" className="btn-primary">
                  WhatsApp
                </a>
              )}
              {instagram && (
                <a href={instagram} target="_blank" rel="noopener noreferrer" className="btn-secondary">
                  Instagram
                </a>
              )}
            </div>
          )}
        </div>
      )}

      {(scheduleTitle || scheduleText) && (
        <div className="mt-12 text-center md:text-left">
          {scheduleTitle && (
            <h2 className="font-display text-2xl font-semibold uppercase tracking-wide">
              {scheduleTitle}
            </h2>
          )}
          {scheduleText && (
            <p className="mt-3 whitespace-pre-line text-muted">{scheduleText}</p>
          )}
        </div>
      )}
    </Section>
  );
};

export default Contact;
